import {LoadingCenter} from "@bounce/shared/ui";
import {AgentPageFrame} from "./AgentPageFrame";

export const AgentPageLoading = () => (
  <AgentPageFrame>
    <LoadingCenter sx={{position: "relative", minHeight: "60vh"}} />
  </AgentPageFrame>
);
